// @flow
import React from 'react'
import styled from 'styled-components'

const Component = styled.select`
  margin-right: 1rem;
  margin-bottom: 1rem;
  width: auto !important;
`

type Props = {
  param: string,
  onChange: Function,
  options: Array<Object>,
  value: string | number | null
}

const Filter = ({ options, param, onChange, value }: Props) => (
  <Component
    value={value}
    className="form-control"
    onChange={(e) => onChange(param, e.target.value)}
  >
    {options.map((option) => (
      <option key={option.value} value={option.value}>
        {option.display}
      </option>
    ))}
  </Component>
)

export default Filter



// WEBPACK FOOTER //
// ./src/views/Search/components/Filter/index.js